import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import { getAddOns } from "store/actions/cartAction";

const ProductDetailModal = ({ isOpen, toggle, data }) => {
  const dispatch = useDispatch();
  const { addOnsDetail } = useSelector((state) => state.cart);
  const { restaurantsDetail } = useSelector((state) => state.restaurant);

  const name = data?.name || data?.menuDetail?.name || "Item Detail";
  const images = data?.images || data?.menuDetail?.images || [];
  const time = data?.estimatedTime || data?.menuDetail?.estimatedTime || "-";
  const variants = data?.variants || data?.menuDetail?.variants || [];
  const labels = data?.fullLabels || [];
  const [selectedImage, setSelectedImage] = useState(images[0]);

  const currency = restaurantsDetail?.currency;

  useEffect(() => {
    dispatch(getAddOns(data?.addOns));
  }, [data?.addOns]);

  const cardBg = "#f0f0f0";
  const cardStyle = {
    backgroundColor: cardBg,
    padding: "14px 18px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    transition: "all 0.2s ease-in-out",
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader
        toggle={toggle}
        className="align-items-center border-bottom py-3"
      >
        <span className="fs--18 fw--500 mb-0 normal-heading">{name || ""}</span>
      </ModalHeader>

      <ModalBody className="py-2">
        <Row className="text-dark fs--14">
          <Col md={5}>
            <div
              className="rounded-lg overflow-hidden"
              style={{ height: "250px" }}
            >
              <img
                src={selectedImage}
                alt={name}
                className="img-fluid"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>

            {images?.length > 1 && (
              <div className={`d-flex flex-wrap mt-2 `} style={{ gap: "8px" }}>
                {images.map((img, idx) => (
                  <img
                    key={idx}
                    src={img}
                    onClick={() => setSelectedImage(img)}
                    alt={`thumb-${idx}`}
                    style={{
                      width: "75px",
                      height: "75px",
                      objectFit: "cover",
                      borderRadius: "20px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      cursor: "pointer",
                      transition: "0.2s ease-in-out",
                      padding: "2px",
                      border:
                        img === selectedImage
                          ? "3px solid red"
                          : "2px solid transparent",
                    }}
                  />
                ))}
              </div>
            )}
          </Col>

          <Col md={7}>
            <div
              style={{
                paddingLeft: "1rem",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ flex: 1 }}>
                {time && (
                  <div className="py-3 py-md-0 mb-0 mb-md-3  fw--500 fw-bold d-flex align-items-center">
                    <strong className="fw--500">Estimated Time:</strong>
                    <span className="fw-normal text-muted ml-2">
                      {time} mins
                    </span>
                  </div>
                )}

                {variants?.length > 0 && (
                  <div className="mb-4">
                    <strong className="fw--500 mb-2">Variants:</strong>
                    {variants?.map((v, idx) => (
                      <div
                        key={idx}
                        className="hover-effect-box"
                        style={{
                          ...cardStyle,
                          marginBottom: "10px",
                        }}
                      >
                        <div className="d-flex justify-content-between">
                          <span>
                            <strong className="fw--700 mb-2">Size:</strong>{" "}
                            {v.size}
                          </span>
                          <span>
                            <strong className="fw--700 mb-2">Price:</strong>{" "}
                            {currency || "$"} {v.price}
                          </span>
                        </div>
                        {v.calories && (
                          <div className="mt-1">
                            <strong className="fw--500">Calories:&nbsp;</strong>
                            <span>{v.calories}</span>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {labels?.length > 0 && (
                  <>
                    <strong className="mb-3 fw--500">Labels: </strong>
                    <div
                      className="d-flex flex-wrap"
                      style={{ gap: "10px", marginBottom: "1.5rem" }}
                    >
                      {labels?.map((label, idx) => {
                        const labelId = `label_${idx}_${label.id}`;
                        return (
                          <div
                            key={label.id}
                            id={labelId}
                            className="hover-effect-box d-flex flex-column align-items-center"
                            style={{
                              ...cardStyle,
                              padding: "10px 12px",
                              width: "100px",
                              textAlign: "center",
                              position: "relative",
                            }}
                          >
                            <img
                              src={label.labelURL}
                              alt={label.label}
                              width={32}
                              height={32}
                              style={{ objectFit: "contain" }}
                            />
                            <span
                              className="mt-2"
                              style={{
                                fontSize: "0.85rem",
                                maxWidth: "100%",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {label.labelName}
                            </span>
                            <UncontrolledTooltip
                              placement="bottom"
                              target={labelId}
                            >
                              {label.labelName}
                            </UncontrolledTooltip>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}

                {addOnsDetail?.length > 0 && (
                  <>
                    <strong className="py-3 fw--500">AddOns</strong>
                    <div
                      className="d-flex flex-column"
                      style={{ gap: "12px", marginBottom: "1rem" }}
                    >
                      {addOnsDetail?.map((addOn, idx) => {
                        const hasDescription = Boolean(
                          addOn?.description?.trim()
                        );

                        return (
                          <div
                            key={idx}
                            className="hover-effect-box d-flex"
                            style={{
                              ...cardStyle,
                              alignItems: hasDescription
                                ? "flex-start"
                                : "center",
                              gap: "14px",
                            }}
                          >
                            <img
                              src={addOn?.image}
                              alt={addOn?.name}
                              width={50}
                              height={50}
                              style={{
                                objectFit: "contain",
                                borderRadius: "6px",
                                flexShrink: 0,
                              }}
                            />

                            <div style={{ flex: 1 }}>
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <strong className="fw--700">
                                  {addOn?.name}
                                </strong>
                                <span>
                                  {"$" + addOn?.price == 0
                                    ? "Free"
                                    : addOn?.price}
                                </span>
                              </div>

                              {hasDescription && (
                                <div
                                  style={{
                                    fontSize: "0.87rem",
                                    color: "#666",
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    lineHeight: "1.3rem",
                                    maxHeight: "2.6rem",
                                    textOverflow: "ellipsis",
                                  }}
                                  title={addOn.description}
                                >
                                  {addOn.description}
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ProductDetailModal;
